import React from 'react'
import Link from '../utils/link'

// Also drawn at hero scale on the homepage (pages/index.js hero-intro).
export const WORDMARK_PATHS = (
  <>
    <path className="bg" d="M21.0011 0C9.40261 0 0 9.4026 0 21.0011C0 32.5995 9.40261 42.0021 21.0011 42.0021H66.8779C78.4763 42.0021 87.8789 32.5995 87.8789 21.0011C87.8789 9.4026 78.4763 0 66.8779 0H21.0011Z" fill="#FF4200" />
    <path className="bg" d="M164.772 0H87.8789V42H164.772V0Z" fill="#FF4200" />
    <path d="M63.6372 22.4969C63.8117 20.201 65.1458 18.6307 67.5417 18.6307C69.9376 18.6307 71.21 20.1776 71.2334 22.4969H63.6372ZM61.4669 23.6203C61.4669 27.9482 63.8373 30.2802 67.5672 30.2802C71.2972 30.2802 72.793 27.9354 73.0675 26.3758V26.0013H71.11C70.91 27.2248 69.8759 28.6206 67.5545 28.6206C65.1097 28.6206 63.65 26.8865 63.6011 24.0927H73.3441V23.0692C73.3441 19.3265 71.31 16.9689 67.5566 16.9689C63.8032 16.9689 61.4691 19.301 61.4691 23.6182M56.9688 23.631C56.9688 26.7864 55.3219 28.5333 52.9027 28.5333C50.4834 28.5333 48.8365 26.7864 48.8365 23.631C48.8365 20.4755 50.4834 18.7158 52.9027 18.7158C55.3219 18.7158 56.9688 20.4627 56.9688 23.631ZM59.0902 29.9802V12.0197H56.8944V18.9924H56.6454C56.0837 18.0562 54.8623 16.9838 52.4537 16.9838C49.1472 16.9838 46.6172 19.2286 46.6172 23.6331C46.6172 28.0376 49.1493 30.2696 52.4537 30.2696C54.8602 30.2696 56.122 29.1972 56.7071 28.1737H56.9561V29.9824H59.0902V29.9802ZM34.3826 23.631C34.3826 20.401 36.0422 18.6797 38.5104 18.6797C40.9787 18.6797 42.6383 20.401 42.6383 23.631C42.6383 26.8609 40.9787 28.5695 38.5104 28.5695C36.0422 28.5695 34.3826 26.8482 34.3826 23.631ZM32.1505 23.631C32.1505 27.9099 34.7209 30.2802 38.5126 30.2802C42.3042 30.2802 44.8746 27.9099 44.8746 23.631C44.8746 19.352 42.3042 16.9711 38.5126 16.9711C34.7209 16.9711 32.1505 19.3414 32.1505 23.631ZM14.5411 20.9989C14.5411 26.8247 18.0222 30.2802 23.0118 30.2802C28.0014 30.2802 30.1717 26.9503 30.4717 24.231V23.8565H28.3014C28.0652 25.9013 26.6311 28.4333 23.0245 28.4333C19.418 28.4333 16.837 25.6523 16.837 20.9989C16.837 16.3455 19.369 13.5645 23.0245 13.5645C26.6801 13.5645 28.0503 15.8348 28.2503 17.9562H30.4079V17.5817C30.159 14.8135 27.9376 11.7197 23.0118 11.7197C18.086 11.7197 14.5411 15.1625 14.5411 21.001" fill="#111" />
    <path d="M144.752 20.5732C144.752 22.7818 146.424 23.767 148.744 24.1649L150.791 24.5011C152.399 24.7628 153.51 25.199 153.51 26.4841C153.51 27.7693 152.425 28.6055 150.316 28.6055C148.207 28.6055 146.699 27.7204 146.55 26.0352H144.492V26.4097C144.805 28.7289 146.888 30.2141 150.318 30.2141C153.748 30.2141 155.608 28.7289 155.608 26.348C155.608 23.967 153.825 23.1542 151.303 22.7308L149.259 22.3946C147.924 22.169 146.852 21.7328 146.852 20.486C146.852 19.2391 147.999 18.5284 149.882 18.5284C151.765 18.5284 153.063 19.2391 153.163 20.8732H155.197V20.4987C154.948 18.3412 153.001 16.9177 149.846 16.9177C146.69 16.9177 144.756 18.2646 144.756 20.5732M132.588 23.567C132.588 20.3987 134.234 18.6518 136.666 18.6518C139.099 18.6518 140.733 20.3987 140.733 23.567C140.733 26.7352 139.086 28.4693 136.666 28.4693C134.247 28.4693 132.588 26.7224 132.588 23.567ZM130.479 17.2049V34.9058H132.675V28.1949H132.924C133.485 29.1311 134.707 30.2035 137.115 30.2035C140.422 30.2035 142.941 27.9587 142.941 23.567C142.941 19.1753 140.422 16.9177 137.115 16.9177C134.709 16.9177 133.449 17.9901 132.862 19.0135H132.613V17.2049H130.481H130.479ZM125.298 29.9162H127.494V17.2049H125.298V29.9162ZM125.26 14.8984H127.517V12.2792H125.26V14.8984ZM116.919 17.2049V29.9162H119.115V22.8308C119.115 19.637 120.861 18.7135 123.493 18.988V17.0922C120.887 16.8305 119.838 17.9156 119.302 19.0008H119.053V17.2049H116.921H116.919ZM101.792 13.775H105.746C109.637 13.775 112.069 16.4432 112.069 20.9349C112.069 25.4266 109.637 28.0949 105.746 28.0949H101.792V13.775ZM99.5093 11.9536V29.9162H105.784C110.974 29.9162 114.365 26.499 114.365 20.9349C114.365 15.3708 110.972 11.9536 105.784 11.9536H99.5093Z" fill="#111" />
  </>
)

// Compact mark for narrow viewports — the wide horizontal wordmark won't fit
// next to the CTA + hamburger below ~800px, so we swap to this 2:1 mark.
const COMPACT_MARK_PATHS = (
  <>
    <path className="bg" d="M215.34 0V95.09C208.93 41.53 163.35 0 108.06 0C48.38 0 0 48.38 0 108.06C0 167.74 48.38 216.12 108.06 216.12C163.35 216.12 208.93 174.6 215.34 121.03V216.12H431.46V0H215.34Z" fill="#FF4200" />
    <path d="M67.0701 108.05C67.0701 138.02 84.9801 155.8 110.65 155.8C136.32 155.8 147.49 138.66 149.03 124.67V122.74H137.86C136.64 133.27 129.26 146.3 110.71 146.3C92.1601 146.3 78.8701 131.99 78.8701 108.05C78.8701 84.11 91.9001 69.8 110.71 69.8C129.52 69.8 136.58 81.4801 137.6 92.3901H148.7V90.47C147.42 76.22 135.99 60.3 110.64 60.3C85.2901 60.3 67.0601 78.01 67.0601 108.05" fill="#111" />
    <path d="M296.92 71.2101H317.27C337.3 71.2101 349.81 84.9501 349.81 108.05C349.81 131.15 337.29 144.89 317.27 144.89H296.92V71.2001V71.2101ZM285.17 61.8401V154.27H317.46C344.16 154.27 361.62 136.68 361.62 108.06C361.62 79.4401 344.16 61.8501 317.46 61.8501H285.17V61.8401Z" fill="#111" />
  </>
)

const Header = ({ data, location }) => {
  const [offCanvas, setOffCanvas] = React.useState(false)

  const hideOffCanvas = () => setOffCanvas(false)
  const toggleOffCanvas = () => setOffCanvas(!offCanvas)

  // Lock body scroll while the drawer is open so the page behind doesn't
  // bounce around on touch devices.
  React.useEffect(() => {
    if (typeof document === 'undefined') return
    const original = document.body.style.overflow
    document.body.style.overflow = offCanvas ? 'hidden' : original
    return () => { document.body.style.overflow = original }
  }, [offCanvas])

  const linkProps = {
    onClick: hideOffCanvas,
    activeClassName: 'is-active',
  }

  // The 2026 nav surfaces only the headline routes; the rest of the menu
  // remains accessible via the off-canvas drawer. /about/ was renamed to
  // /studio/ in the rebrand — until the CMS menu is updated, rewrite the URI
  // and label here so the nav points at the live page (the redirect at the
  // edge still handles any deep links from the wild).
  const primaryRoutes = ['/project/', '/service/', '/service/help-with-your-build/', '/studio/', '/journal/']
  const rawMenuItems = data?.headerMenu?.menuItems?.nodes || []
  const menuItems = rawMenuItems.map(item =>
    item.uri === '/about/'
      ? { ...item, uri: '/studio/', label: 'Studio' }
      : item
  )
  const primaryItems = menuItems.filter(item => primaryRoutes.includes(item.uri))

  return (
    <>
      {/* Homepage intro only (shown by .cd-intro-on): a full-colour copy of
          the wordmark, fixed exactly over the nav's own. The nav blends with
          the reel while it plays, which would invert the real logo; this
          copy sits above the blend. Decorative; the nav's link is the real one. */}
      <div className="nav-2026-intro-mark" aria-hidden="true">
        <div className="nav-2026__inner">
          <span className="nav-2026__mark">
            <span className="nav-2026__wordmark">
              <svg className="nav-2026__mark-full" width="165" height="42" viewBox="0 0 165 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                {WORDMARK_PATHS}
              </svg>
              <svg className="nav-2026__mark-compact" width="432" height="217" viewBox="0 0 432 217" fill="none" xmlns="http://www.w3.org/2000/svg">
                {COMPACT_MARK_PATHS}
              </svg>
            </span>
          </span>
        </div>
      </div>
      <nav className="nav-2026" aria-label="Primary">
        <div className="nav-2026__inner">
          <Link to="/" title="CodeDrips" className="nav-2026__mark" {...linkProps}>
            <span className="nav-2026__wordmark" aria-label="CodeDrips">
              <svg className="nav-2026__mark-full" width="165" height="42" viewBox="0 0 165 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                {WORDMARK_PATHS}
              </svg>
              <svg className="nav-2026__mark-compact" width="432" height="217" viewBox="0 0 432 217" fill="none" xmlns="http://www.w3.org/2000/svg">
                {COMPACT_MARK_PATHS}
              </svg>
            </span>
          </Link>
          <div className="nav-2026__links">
            {primaryItems.map(({ label, uri }) => (
              <Link key={uri} to={uri} {...linkProps}>{label}</Link>
            ))}
            <Link to="/contact/" className="nav-2026__cta" {...linkProps}>
              Start a project <span aria-hidden="true">→</span>
            </Link>
            <button
              type="button"
              onClick={toggleOffCanvas}
              className="nav-2026__hamburger"
              aria-label="Open menu"
              aria-expanded={offCanvas}
            >
              <span /><span /><span />
            </button>
          </div>
        </div>
      </nav>
      <div
        className={`off-canvas-2026__backdrop ${offCanvas ? 'is-open' : ''}`}
        onClick={hideOffCanvas}
        aria-hidden="true"
      />
      <aside
        className={`off-canvas-2026 ${offCanvas ? 'off-canvas-2026--active' : ''}`}
        aria-label="Site menu"
        aria-hidden={!offCanvas}
      >
        <div className="off-canvas-2026__inner">
          <header className="off-canvas-2026__top">
            <span className="off-canvas-2026__crumb">§ Menu / Site map</span>
            <button
              type="button"
              onClick={hideOffCanvas}
              className="off-canvas-2026__close"
              aria-label="Close menu"
            >
              <span aria-hidden="true">Close</span>
              <span aria-hidden="true" className="off-canvas-2026__close-x">×</span>
            </button>
          </header>

          <ul className="off-canvas-2026__list">
            {menuItems.map(({ label, uri }, i) => (
              <li key={uri || i}>
                <Link to={uri} {...linkProps}>
                  <span className="num">/{String(i + 1).padStart(2, '0')}</span>
                  <span className="label">{label}</span>
                  <span className="arrow" aria-hidden="true">→</span>
                </Link>
              </li>
            ))}
          </ul>

          <footer className="off-canvas-2026__foot">
            <Link to="/contact/" className="off-canvas-2026__cta" {...linkProps}>
              Start a project <span aria-hidden="true">→</span>
            </Link>
            <div className="off-canvas-2026__contact">
              <a href="mailto:hello@codedrips.com">hello@codedrips.com</a>
              <span>Melbourne, Australia</span>
            </div>
          </footer>
        </div>
      </aside>
    </>
  )
}

export default Header
